import BaseApiClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkListApi extends BaseApiClient {
  public getList (word: string, year: number) {
    const path = '/v1/external-links'
    const url = new URL(process.env.VUE_APP_API_URL + path)
    let params = new URLSearchParams({})

    if (word !== '') {
      params.append('word', word)
    }

    if (year !== 0) {
      params.append('year', String(year))
    }

    url.search = params.toString()

    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new ExternalLinkListApi()
